<template>
  <div class="modal" v-if="seen">
    <div class="permanent" v-if="!done">
      <span>Extracting <strong>{{ str_text(name) }}.zip</strong></span>
      <span><img src="@/assets/30.gif" /></span>
    </div>
    <div class="permanent compressed" v-if="done">
      <span>Extracting of <strong>{{ str_text(name) }}</strong> completed</span>
      <span class="close-btn" @click="closebox">Ok</span>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { setTimeout } from 'timers'
import cookies from '@/services/cookies'

export default {
  data() {
    return {
      name: '',
      seen: false,
      index: null,
      loader: false,
      found: false,
      done: false,
      src: ''
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_TOTAL_USED_SPACE',
      'SET_DIRECTORY_CHILDREN',
      'SET_CURRENT_DIRECTORY',
      'SET_PATH',
      'SORT_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'UPDATE_DIRECTORY_CHILDREN',
      'EMPTY_FILE_ACTION',
      'EMPTY_FILES_INDEX',
      'SET_FILE_ACTION',
      'SET_SELECT_ALL'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    str_text(str) {
      if (str.length > 24) {
        let fSeg = str.substring(0, 5)
        let sSeg = str.substr(str.length - 7, 7)

        return fSeg + '....' + sSeg
      }
      return str
    },
    load(index) {
      this.name = this.$store.getters.DIRECTORY_CHILDREN[index].dir
      this.seen = true
      this.done = false
      this.index = index
      this.id = this.$store.getters.DIRECTORY_CHILDREN[index].id

      let that = this

      let data = {
        token: cookies.getCookie('token'),
        id: this.id,
        rename: false
      };

      this.$socket.emit('uncompress', data, function (data) {
        if (data.message === 'completed') {
          that.done = true
          that.UPDATE_DIRECTORY_CHILDREN(data.directory_children)
          that.SORT_DIRECTORY_CHILDREN()
          //let total_space_used = that.$store.getters.GET_TOTAL_USED_SPACE - data.trash_size
          //that.UPDATE_TOTAL_USED_SPACE(total_space_used)

          that.$store.getters.DIRECTORY_CHILDREN[that.index].is_checked = false

          if (that.src == 'group') {
            that.EMPTY_FILE_ACTION()
            that.EMPTY_FILES_INDEX()
            that.SET_FILE_ACTION('')
            that.SET_SELECT_ALL(false)
          }
        }

        if (data.message === 'exist') {
          that.done = false
          that.seen = false
          that.fileExist(data.new_name)
        }

        if (data.data === false) {
          that.done = false
          that.seen = false
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    fileExist(new_name) {
      this.$parent.file_exist(this.index, '', '', new_name, 'uncompress')
    },
    closebox(evt) {
      if (evt.target.className === 'close-btn') {
        this.done = false
        this.seen = false
      }
    }
  }
}
</script>